import { pendingNavHrefAtom, pendingNavRequestAtom } from '@/atoms/sideNavAtoms';
import { type createStore } from 'jotai';
import { type NextRouter } from 'next/router';
import { routePath } from './nav-item.utils';

/** Take ownership only when this click actually needs a page cover. A same-page
 * Link must leave the previous request's owner intact so its cancellation clears
 * that cover. NavItem exposes no replace/scroll/shallow/locale overrides; this
 * push preserves its current Link defaults while giving us the settling promise. */
export function navigateWithPendingCover(
  event: { preventDefault: () => void },
  href: string,
  router: Pick<NextRouter, 'asPath' | 'push'>,
  store: ReturnType<typeof createStore>
) {
  const destination = routePath(href);
  if (destination === routePath(router.asPath)) return;
  if (store.get(pendingNavHrefAtom) !== destination) return;
  event.preventDefault();
  const request = Symbol('sidebar-navigation');
  store.set(pendingNavRequestAtom, request);
  const clearPending = () => {
    if (store.get(pendingNavRequestAtom) !== request) return;
    // An href write also resets ownership, even when the href is unchanged.
    if (store.get(pendingNavHrefAtom) === destination)
      store.set(pendingNavHrefAtom, null);
  };
  try {
    void router.push(href).then(clearPending, clearPending);
  } catch {
    clearPending();
  }
}
